export default __webpack_public_path__ + "static/media/Cab 412 OS.208b1fcd.webp";